import React from "react";

const OverviewYEI = () => {
  return (
    <div className="flex md:space-x-2">
      <div className="md:w-3/4">
        <div className="border-2 p-2 border-sdorange inline-block mb-1 ">
          <p>Course Overview</p>
        </div>
        <div>
          <img src="/image-fix/random-images/international-relations-diplomat.jpg" />
        </div>
        <div id="overview">
          <p className="text-justify">
            The Young Emerging International Relations and Diplomatic Practice
            Programme equips participants with foundational and advanced skills
            in diplomacy and global governance. This 30-ECTS postgraduate
            certificate combines theoretical insights with practical
            applications, including simulations, case studies, and hands-on
            exercises. Students explore international relations theories,
            diplomatic protocols, climate diplomacy, and emerging global trends.
            With a focus on cross-cultural communication, gender inclusivity,
            and strategic negotiation, graduates are prepared for impactful
            roles in diplomacy, international organisations, and global
            policy-making. The programme also serves as a stepping stone to the
            Postgraduate Diploma in Advanced International Relations and
            Diplomatic Practice or the Master of Arts in Diplomacy and
            International Relations.
          </p>
        </div>
      </div>
      <div className="md:w-1/4 hidden p-2 rounded-lg border-2 border-sdorange bg-sdbodywhite md:flex items-center">
        {" "}
        <img
          src="/image-fix/academic-programmes/executive-education/schima.png"
          className="w- w-full"
        />
      </div>
    </div>
  );
};

export default OverviewYEI;
